import styles from './BottomNav.module.scss'
import { Size } from 'types/size'
import ColumnComponent from 'componentsUnits/columnComponent'
import Break from 'componentsUnits/break'
import Subtitle from 'componentsUnits/subtitle'
import { IconType } from 'react-icons'

interface Props {
  ActiveIcon: IconType
  InactiveIcon: IconType
  ExtraElement?: JSX.Element
  isActive: boolean
  text: string
  onClickOnActive: () => void
  onClickOnInactive: () => void
}

const BottomNavButton = (props: Props) => {

  const handleOnClick = () => {
    console.log('clicked')
    if (props.isActive) {
      props.onClickOnActive()
    }
    else {
      props.onClickOnInactive()
    }
  }

  return (
    <div className={styles.bnTab} onClick={handleOnClick}>
      <ColumnComponent centerH>
        {props.isActive ?

          <>
            {props.ExtraElement}
            <props.ActiveIcon size="26" color='var(--color-primary)' />
          </>
          :
          <>
            <props.InactiveIcon size="26" color={'var(--color-dark)'} />
          </>
        }
        <Break size={Size.xxSmall} />
        <Subtitle noMargin normalWeight size={Size.xxSmall} color={props.isActive ? 'var(--color-primary)' : 'var(--color-dark)'}
          text={props.text} />
      </ColumnComponent>
    </div>
  )
}

export default BottomNavButton
